module.exports = __webpack_public_path__ + "img/DSC_0180 teatro ilpa 2.851051e5.jpg";